import { twMerge } from 'tailwind-merge';

import { useClientHasRendered } from '@domain/session/useClientHasRendered';
import { Button } from '../../../Clickables/Buttons/Button';

interface IProps {
  className: string;
  onDownloadAppClick: () => void;
}

export const CommentCTA = ({ className, onDownloadAppClick }: IProps) => {
  const hasClientRendered = useClientHasRendered();

  return hasClientRendered ? (
    <div className={twMerge('body-text-md', className)}>
      <Button
        variant="textNone"
        onClick={onDownloadAppClick}
        className="text-tuna-shade font-semibold"
      >
        Get the Fishbrain app
      </Button>{' '}
      to comment
    </div>
  ) : (
    <></>
  );
};
